'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('aricModule')

.factory('commonAricService', ['$http', '$q', function ($http, $q) {
    var baseUrl = environment.apiUrl + '/Pilot/api/ARIC';

    var service = {};

    // Get Control Owners And Status
    service.getControlOwnersAndStatus = function () {
        return $http
            .get(baseUrl + '/Control/ByOwner')
            .then(function (response) { return response.data; });
    };

    // Get Controls By Owner
    service.getControlsByOwner = function (ownerId) {
        return $http
            .get(baseUrl + '/Control/ByOwner/' + ownerId)
            .then(function (response) { return response.data; });
    };

    // Get Control
    service.getControl = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId)
            .then(function (response) { return response.data; });
    };

    // Get Control Testing Infos
    service.getControlTestingInfos = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId + '/TestingInfo')
            .then(function (response) { return response.data; });
    };

    // Get Control Review Infos
    service.getControlReviewInfos = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId + '/ReviewInfo')
            .then(function (response) { return response.data; });
    };

    // Get Control To Assess
    service.getControlToAssess = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId + '/Assessment')
            .then(function (response) { return response.data; });
    };

    // Get AssessmentsByControlId
    service.getAssessmentsByControlId = function (controlId) {
        return $http
            .get(baseUrl + '/Control/' + controlId + '/Assessment/List')
            .then(function (response) { return response.data; });
    };

    // Save control assessment
    service.saveControlAssessment = function (controlToAssess) {
        return $http
            .post(baseUrl + '/Control/' + controlToAssess.Control.ControlID +
                  '/Assessment/' + controlToAssess.Assessment.ControlAssessmentID + '/Save',
                  controlToAssess)
            .then(function (response) { return response.data; });
    };

    // Submit control assessment
    service.submitControlAssessment = function (controlToAssess) {
        return $http
            .post(baseUrl + '/Control/' + controlToAssess.Control.ControlID +
                  '/Assessment/' + controlToAssess.Assessment.ControlAssessmentID + '/Submit',
                  controlToAssess)
            .then(function (response) { return response.data; });
    };

    // Cancel control assessment
    service.cancelControlAssessment = function (controlToAssess) {
        return $http
            .post(baseUrl + '/Control/' + controlToAssess.Control.ControlID +
                  '/Assessment/' + controlToAssess.Assessment.ControlAssessmentID + '/Cancel',
                  controlToAssess)
            .then(function (response) { return response.data; });
    };

    // Submit Control Testing ReadyForReview
    service.submitControlTestingReadyForReview = function (assessmentToSubmitForReview) {
        return $http
            .post(baseUrl + '/Control/' + assessmentToSubmitForReview.ControlID + '/SubmitReadyForReview',
                  assessmentToSubmitForReview)
            .then(function (response) { return response.data; });
    };

    // Review Control
    service.reviewControl = function (controlAssessment) {
        return $http
            .post(baseUrl + '/Control/' + controlAssessment.ControlID + '/Review',
                  controlAssessment)
            .then(function (response) { return response.data; });
    };

    // Get Controls To Certify By Owner
    service.getControlsToCertifyByOwner = function (ownerId) {
        return $http
            .get(baseUrl + '/Certification/Control/ByOwner/' + ownerId)
            .then(function (response) { return response.data; });
    };

    // Save Control Certification
    service.saveControlCertification = function (aricControl) {
        var cloneAricControl = _.cloneDeep(aricControl);
        cloneAricControl.Assessment = cloneAricControl.ControlAssessment;
        delete cloneAricControl.ControlAssessment;
        return $http
            .post(baseUrl + '/Certification/Control/' + cloneAricControl.ControlID + '/ByOwner/' + cloneAricControl.OwnerID + '/Save',
                  cloneAricControl)
            .then(function (response) {
                response.data.ControlAssessment = response.data.Assessment;
                delete response.data.Assessment;
                return response.data;
            });
    };

    // Submit Control Certification
    service.submitControlCertification = function (aricControl) {
        return $http
            .post(baseUrl + '/Certification/Control/ByOwner/' + aricControl.OwnerID + '/Submit')
            .then(function (response) { return response.data; });
    };

    // Review Certification
    service.reviewCertification = function (controlId) {
        return $http
            .post(baseUrl + '/Certification/Control/' + controlId + '/Review')
            .then(function (response) { return response.data; });
    };

    // Get Certification Tasks for Owner
    service.getCertificationTasks = function () {
        return $http
                .get(baseUrl + '/Certification/TaskByOwner')
                .then(function (response) { return response.data; });

    };

    // Get Certification Attachments for Owner
    service.getCertificationAttachments = function (ControlOwnerAssessmentID) {
        return $http
            .get(baseUrl + '/Certification/ControlOwnerAssessment/' + ControlOwnerAssessmentID + '/Attachments')
            .then(function (response) { return response.data; });

    };

    // Get Owner Control Assessments
    service.getControlOwnerAssessmentByOwnerID = function (ownerId) {
        return $http
            .get(baseUrl + '/Certification/ControlOwnerAssessment/ByOwner/' + ownerId)
            .then(function (response) {
                return response.data;
            });
    };

    // Save Owner Control Assessment
    service.saveControlOwnerAssessment = function (controlOwnerAssessment) {

        return $http
            .put(baseUrl + '/Certification/ControlOwnerAssessment/' + controlOwnerAssessment.ControlOwnerAssessmentID,
                  controlOwnerAssessment)
            .then(function (response) {
                return response.data;
            });
    };


    return service;
}]);
